import {TweenMax, TimelineMax, Power2} from "gsap";

const settings = {
    burgerContainerSelector: '[js-burger]',
    burgerTopSelector: '[js-burger-top]',
    burgerMiddleSelector: '[js-burger-middle]',
    burgerBottomSelector: '[js-burger-bottom]',
};

/**
 * On récupère le container du burger pour le binder à un event click par la suite
 * @type {Element}
 */
const burger = document.querySelector(settings.burgerContainerSelector);

/**
 * On initialise l'event click sur le burger
 * @param callback
 */
export const initBurger = callback => {
    if (burger) {
        burger.addEventListener('click', callback);
    }
}

/**
 * Ouverture du burger
 */
export const openBurger = () => {
    animation.play()
}

/**
 * Fermeture du burger
 */
export const closeBurger = () => {
    animation.reverse();
}

/**
 * Custom animation pour le burger, assez simple on fade la barre du milieu et on croise les deux autres
 * @type {module:gsap/gsap-core.TimelineMax}
 */
const animation = new TimelineMax({paused: true})
    .add([
        TweenMax.to(settings.burgerMiddleSelector, .4, {opacity: 0, ease:Power2.easeOut}),
        TweenMax.to(settings.burgerTopSelector, .4, {y: 6, rotationZ: 45, transformOrigin: '50% 50%', ease:Power2.easeOut}),
        TweenMax.to(settings.burgerBottomSelector, .4, {y: -6, rotationZ: -45, transformOrigin: '50% 50%', ease:Power2.easeOut}),
    ]);
